<template>
  <div class="my-pagination flex-box">
    <div class="my-pagination-list">
      <ul>
        <li
          v-for="item in pageList"
          :class="pagerCount == item ? 'active' : ''"
          :key="item"
          @click="selectCount(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="btn-group flex-box">
      <button @click="prev">上一页</button>
      <button @click="next">下一页</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["page-size", "pager-count", "total"],
  data() {
    return {
      pageTotal: [],
    };
  },
  computed: {
    pageList() {
        let total = Math.ceil(this.total / this.pageSize)
        let count = this.pagerCount || 1
      var left = 1;
      var right = total;
      var ar = [];
      if (total >= 5) {
        if (count > 3 && count < total - 2) {
          left = count - 2;
          right = count + 2;
        } else {
          if (count <= 3) {
            left = 1;
            right = 5;
          } else {
            right = total;
            left = total - 4;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  methods: {
    prev() {
         let count = this.pagerCount - 1 || 1
        this.$emit("selectCount", count);
    },
    next() {
        let total = Math.ceil(this.total / this.pageSize)
        
        let count = this.pagerCount + 1
       
        count = total - count < 0 ? total : count 
        
        this.$emit("selectCount", count);
    },
    selectCount(item) {
      this.$emit("selectCount", item);
    },
  },
  created() {},
  watch: {
    // pagerCount(newCount, oldCount) {
    //   console.log(oldCount, newCount);
    // },
  },
};
</script>
<style lang="scss" scoped>
$li-width: 10px;
.my-pagination {
  // width: calc();
  font-size: 0.12rem;
  margin: 0.2rem auto;
  width: 5.1rem;
  text-align: center;
}
.my-pagination-list {
  overflow: hidden;
  width: calc(10 * 27px);
  white-space: nowrap;
  ul {
    li {
      display: inline-block;
      width: $li-width;
      height: $li-width;
      line-height: $li-width;
      margin: 10px;
      
      padding: 5px;
      &:hover {
        cursor: default;
      }
    }
  }
}
.active {
  color: $color-blue;
  border: 1px solid $color-skyblue;
}
.btn-group{
    width:1.5rem ;
    button{
        border: 1px solid #EEEEEE;
        background: #fff;
        font-size: 0.12rem;
        outline:none;
        
    }
}
</style>